import Vue, { VueConstructor, ComponentOptions } from 'vue';

export interface AvailableComponent {
  component: () => Promise<{
    default: ComponentOptions<Vue> | VueConstructor<Vue>
  }>;
  domain: string;
  allowMultiple?: boolean;
  description?: string;
}

export const availableComponents: Record<string, AvailableComponent> = {
  'Location': {
    component: () => import('@/module/configuration/location/Location.vue'),
    domain: 'Location',
    allowMultiple: true,
    description: 'Manages physical locations and their hierarchies'
  },
  'Storage': {
    component: () => import('@/module/configuration/storage/Storage.vue'),
    domain: 'StorageDevice',
    allowMultiple: true,
    description: 'Handles storage devices and their configurations'
  },
  'Company': {
    component: () => import('@/module/configuration/company/Company.vue'),
    domain: 'Company',
    allowMultiple: false,
    description: 'Company management and settings'
  },
  'Document': {
    component: () => import('@/module/documents/Documents.vue'),
    domain: 'Document',
    allowMultiple: true,
    description: 'Document management system'
  },
  'Survey': {
    component: () => import('@/module/configuration/survey/Survey.vue'),
    domain: 'surveyAdm',
    allowMultiple: true,
    description: 'Survey creation and management'
  },
  'Input': {
    component: () => import('@/module/configuration/input/Input.vue'),
    domain: 'Input',
    allowMultiple: true,
    description: 'Input management for agricultural processes'
  },
  'Culture': {
    component: () => import('@/module/configuration/product/Product.vue'),
    domain: 'Culture',
    allowMultiple: true,
    description: 'Agricultural product and culture management'
  },
  'Equipment': {
    component: () => import('@/module/configuration/equipment/Equipment.vue'),
    domain: 'Equipment',
    allowMultiple: true,
    description: 'Equipment and machinery management'
  },
  'Operator': {
    component: () => import('@/module/configuration/operator/Operator.vue'),
    domain: 'Operator',
    allowMultiple: true,
    description: 'Operator and personnel management'
  },
  'Producer': {
    component: () => import('@/module/configuration/producer/Producer.vue'),
    domain: 'Producer',
    allowMultiple: true,
    description: 'Producer management and tracking'
  },
  'Season': {
    component: () => import('@/module/configuration/season/Season.vue'),
    domain: 'Season',
    allowMultiple: true,
    description: 'Growing season management'
  },
  'Structure': {
    component: () => import('@/module/configuration/structures/Structure.vue'),
    domain: 'Structure',
    allowMultiple: true,
    description: 'Organizational structure management'
  },
  'Process': {
    component: () => import('@/module/configuration/process/Process.vue'),
    domain: 'Process',
    allowMultiple: true,
    description: 'Process and workflow management'
  },
  'PersonInCharge': {
    component: () => import('@/module/configuration/authority/Authority.vue'),
    domain: 'PersonInCharge',
    allowMultiple: true,
    description: 'Authority and responsibility management'
  },
  'Role': {
    component: () => import('@/module/configuration/roles/Roles.vue'),
    domain: 'Role',
    allowMultiple: false,
    description: 'User role and permission management'
  },
  'TokenWallet': {
    component: () => import('@/module/tokens/wallet/IndexView.vue'),
    domain: 'TokenWallet',
    allowMultiple: false,
    description: 'Token wallet and transaction management'
  },
  'TokenStock': {
    component: () => import('@/module/tokens/stock/IndexView.vue'),
    domain: 'TokenStock',
    allowMultiple: false,
    description: 'Token inventory management'
  },
  'TokenContract': {
    component: () => import('@/module/tokens/contract/IndexView.vue'),
    domain: 'TokenContract',
    allowMultiple: false,
    description: 'Smart contract management for tokens'
  },
  'CustomReport': {
    component: () => import('@/module/reports/custom/IndexView.vue'),
    domain: 'CustomReport',
    allowMultiple: false,
    description: 'QAP Reports and Sustainability Declarations'
  },
  'Record': {
    component: () => import('@/module/records/RecordsTabsComponent.vue'),
    domain: 'Record',
    allowMultiple: true,
    description: 'Record keeping and documentation'
  },
  'PreRecord': {
    component: () => import('@/module/prerecords/RecordsTabsPreComponent.vue'),
    domain: 'PreRecord',
    allowMultiple: true,
    description: 'Preliminary record management'
  },
  'Translations': {
    component: () => import('@/module/configuration/translations/IndexView.vue'),
    domain: 'Translations',
    allowMultiple: false,
    description: 'Language and translation management'
  },
  'StorageDeviceType': {
    component: () => import('@/module/configuration/storageTypes/StorageTypes.vue'),
    domain: 'StorageDeviceType',
    allowMultiple: false,
    description: 'Storage device type configuration'
  },
  'Units': {
    component: () => import('@/module/configuration/units/Units.vue'),
    domain: 'All',
    allowMultiple: false,
    description: 'Unit of measurement management'
  }
};
